import { Vue } from 'vue-property-decorator'
import { ServiceRequestRepository } from './ServiceRequestAttachmentUnitRepository'
import ServiceRequestModel from '../../../ServiceRequestModel'
import { JtechStore } from 'src/plugins/mobx'

export default class ServiceRequestAttachmentUnitController {
  state = ServiceRequestModel.getInstance();

  static getInstance () {
    return JtechStore.getSingleton('ServiceRequestAttachmentUnitController', new ServiceRequestAttachmentUnitController())
  }

  async loadDatatable () {
    return await ServiceRequestRepository.loadDatatable()
  }

  async loadDatatableModel (params) {
    return await ServiceRequestRepository.loadDatatableModel(params)
  }

  async loadForm () {
    return await ServiceRequestRepository.loadForm()
  }

  async loadFormAlterar (params) {
    return await ServiceRequestRepository.loadFormAlterar(params)
  }

  async createUnitAttachment (params) {
    return await ServiceRequestRepository.createUnitAttachment(params)
  }

  async deleteAttachment (id) {
    await ServiceRequestRepository.deleteAttachment(id)
  }

  async downloadFile (filePath, nmIdentificacaoParserFile) {
    return await ServiceRequestRepository.downloadFile(filePath, nmIdentificacaoParserFile)
  }
}
